import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {

    const [authToken, setAuthToken] = useState(localStorage.getItem('authToken') || null);
    const [refreshToken, setRefreshToken] = useState(localStorage.getItem('refreshToken') || null);

    const login = (token, refreshToken) => {
        setAuthToken(token);
        setRefreshToken(refreshToken);
        localStorage.setItem('authToken', token);
        localStorage.setItem('refreshToken', refreshToken);
    };

    const logout = () => {
        setAuthToken(null);
        setRefreshToken(null);
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
    };

    return (
        <AuthContext.Provider value={{ authToken, refreshToken, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContext;